import RangeSlider from './range-slider-component';
import RangeSliderService from './range-slider-service';

import './range-slider.scss';
const MODULE_NAME = 'App.Directives.RangeSlider';
const module = angular
    .module(MODULE_NAME, [
        'vr.directives.slider',
    ])
    .directive(RangeSlider.DIRECTIVE_NAME, RangeSlider)
    .service(RangeSliderService.SERVICE_NAME, RangeSliderService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/directives/range-slider/range-slider-module.js